import { render, staticRenderFns } from "./MateriePrime.vue?vue&type=template&id=7942c0c8"
import script from "./MateriePrime.vue?vue&type=script&lang=js"
export * from "./MateriePrime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports